import axios from 'axios';
import { toast } from 'sonner';
import { getApiUrl } from '../utils/api';

const API_URL = getApiUrl();
export const DOWNLOADS_CHANGED = 'download-requests-changed';

const saveBlob = (data, filename, type) => {
  const url = window.URL.createObjectURL(new Blob([data], { type: type || 'text/csv;charset=utf-8;' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

const filenameFrom = (headers, fallback) => {
  const m = (headers?.['content-disposition'] || '').match(/filename="?([^";]+)"?/);
  return m ? m[1] : fallback;
};

// Returns true when the file was saved now, false when it was queued.
export const gatedDownload = async (path, fallbackName) => {
  const res = await axios.get(`${API_URL}${path}`, { withCredentials: true, responseType: 'blob' });
  if (res.status === 202) {
    const info = JSON.parse(await res.data.text());
    toast.info(info.message || 'Your file will be automatically downloaded in 30 minutes.', { duration: 8000 });
    window.dispatchEvent(new Event(DOWNLOADS_CHANGED));
    return false;
  }
  saveBlob(res.data, filenameFrom(res.headers, fallbackName), res.headers['content-type']);
  return true;
};

export const downloadQueuedFile = async (req) => {
  const sep = req.query ? `?${req.query}&` : '?';
  const res = await axios.get(`${API_URL}${req.path}${sep}download_request_id=${req.request_id}`, {
    withCredentials: true, responseType: 'blob',
  });
  saveBlob(res.data, req.filename || filenameFrom(res.headers, 'export.csv'), res.headers['content-type']);
};
